import RHFDictionary from '../RHFDictionary';
import { useAccount } from 'iomart-hooks';
import type { Columns } from 'src/@types/common';

const DICTIONARY_COLUMNS: (Columns & { minWidth?: number; maxWidth?: number })[] = [
  {
    name: 'name',
    subname: 'currency',
    label: 'Name',
    align: 'left',
    nameLines: 1,
    subNameLines: 1,
    minWidth: 160,
    width: 220,
    maxWidth: 320,
  },
];

type RHFAccountProps = {
  name: string;
  label?: string;
  multiple?: boolean;
  disabled?: boolean;
  /** Фильтр: только с синхронизацией */
  withSync?: boolean;
  /** Доп. фильтры (например currency для списка счетов по валюте) */
  filters?: Record<string, unknown>;
  /** Ширина Drawer справочника */
  drawerWidth?: Record<string, string | number>;
};

export default function RHFAccount({
  name,
  label = 'Account',
  multiple = false,
  disabled,
  withSync,
  filters: filtersProp,
  drawerWidth = { xs: '100%', sm: 480 },
}: RHFAccountProps) {
  const filters = { ...(withSync === true && { withSync: true }), ...filtersProp };

  return (
    <RHFDictionary
      name={name}
      label={label}
      useHook={useAccount}
      columns={DICTIONARY_COLUMNS}
      multiple={multiple}
      optionsLabel="name"
      getOptionLabel={(opt: any) => opt?.name || `#${opt?.id}` || ''}
      searchName="name"
      pageSize={10}
      disabled={disabled}
      filters={filters}
      drawerWidth={drawerWidth}
    />
  );
}
